/**
 * Centralized API client with error handling and type safety.
 */

import { getAntiForgeryToken } from './helpers';

export interface ApiResponse<T = any> {
    success: boolean;
    data?: T;
    message?: string;
}

/**
 * Fetch JSON data from an API endpoint with error handling
 */
export async function fetchJson<T>(url: string, options?: RequestInit): Promise<T> {
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
}

/**
 * POST JSON data to an API endpoint
 */
export async function postJson<T>(url: string, data: any): Promise<ApiResponse<T>> {
    return fetchJson<ApiResponse<T>>(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'RequestVerificationToken': getAntiForgeryToken()
        },
        body: JSON.stringify(data)
    });
}

/**
 * Build a query string from an object
 */
export function buildQueryString(params: Record<string, string | number | string[]>): string {
    const parts: string[] = [];
    for (const [key, value] of Object.entries(params)) {
        if (Array.isArray(value)) {
            value.forEach(v => parts.push(`${key}=${encodeURIComponent(v)}`));
        } else {
            parts.push(`${key}=${encodeURIComponent(value)}`);
        }
    }
    return parts.join('&');
}
